import { BulkOrdering } from 'src/shared/types/bulkOrdering';

import { Typography } from 'src/shared/components/ui';

import MarkdownContent from '../../product-detail/ui/updates-tab/markdown-content/MarkdownContent';

interface OrderDetailsModalTabProps {
  order: BulkOrdering | null;
}

const OrderDetailsModalTab: React.FC<OrderDetailsModalTabProps> = ({
  order
}) => {
  if (!order) return null;

  return (
    <>
      <div>
        <div className="px-5 flex flex-col gap-5 pb-7">
          <Typography variant="h5" weight="bold">
            Notes
          </Typography>

          {order?.details && (
            <div className="flex flex-col">
              <Typography
                variant="body-1"
                weight="medium"
                className="text-secondary-text"
              >
                Description
              </Typography>
              <MarkdownContent markdownString={order?.details} />
            </div>
          )}

          {order?.sku_spec && (
            <div className="flex flex-col">
              <Typography
                variant="body-1"
                weight="medium"
                className="text-secondary-text"
              >
                SKU Specifications
              </Typography>

              <MarkdownContent markdownString={order?.sku_spec} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderDetailsModalTab;
